//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Box } from '@mui/material'
import { ExchangeRateTypeEnum, PoolTypeEnum, RoleEnum } from '@shared/Enums'
import { EthAddr } from '@shared/SchemaTypes'

import React from 'react'

import ButtonModal from '@react/components/ButtonModal'
import { useOtChainState, useOtChainTimestamp, useOtSelector } from '@react/redux/store'
import { PoolDynamicOverviewCTO } from '@shared/sharedTypes'

import { ETH_ADDR_ZERO } from '@shared/SchemaTypes'

import AdminPoolRemoveForm from '@react/admin/AdminPoolRemoveForm'
import LytSetExchangeRateForm from '@react/lyt/LytSetExchangeRateForm'
import LytSetIndicativeInterestAndCollateralRateForm from './LytSetIndicativeInterestAndCollateralRateForm'

export default function LytPoolActionModals(props: { poolAddr: EthAddr; poolName: string }): React.ReactElement {
  const { poolAddr } = props

  const {
    userConnection: { roleEnum },
  } = useOtChainState()

  const poolBaseOverviewCTO = useOtSelector((state) => state.poolState.poolOverviewCTOs[poolAddr ?? ETH_ADDR_ZERO])
  const poolDynamicOverviewCTO =
    poolBaseOverviewCTO?.poolType === PoolTypeEnum.Dynamic ? (poolBaseOverviewCTO as PoolDynamicOverviewCTO) : undefined
  // if (!poolDynamicOverviewCTO || roleEnum === RoleEnum.LENDER) {
  //   return <div></div>
  // }
  const chainTimestamp = useOtChainTimestamp()

  const canRemovePool = roleEnum === RoleEnum.PROTOCOL_MANAGER
  const isCompoundingVault = poolDynamicOverviewCTO?.exchangeRateType === ExchangeRateTypeEnum.Compounding
  const chainDayNumber = Math.floor(chainTimestamp / 86400)
  const canAccrueExchangeRate = poolDynamicOverviewCTO && poolDynamicOverviewCTO.exchangeRateSetDay < chainDayNumber

  return (
    <Box
      data-testid={'DynamicBorrowerAdminPoolActionModals'}
      px={0}
      py={2}
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        direction: 'row',
        gap: 2,
      }}
    >
      {isCompoundingVault && (
        <ButtonModal title={'Accrue'} variant="primary" disabled={!canAccrueExchangeRate} modalWidth={800}>
          <LytSetExchangeRateForm poolAddr={poolAddr} />
        </ButtonModal>
      )}

      {canRemovePool && (
        <ButtonModal title={'Remove Pool'} variant="primary">
          <AdminPoolRemoveForm poolAddr={poolAddr} />
        </ButtonModal>
      )}
      {/* {canApproveTransferDestination && (
        <ButtonModal title={'Approve Cross-Vault Transfer Destination'} variant="tertiary">
          <AdminApproveTransferDestination poolAddr={poolAddr}></AdminApproveTransferDestination>
        </ButtonModal>
      )} */}

      {/* TODO: Limit Operator role. Review parent components so Operator role see this component
      https://open-trade.atlassian.net/wiki/spaces/SD/pages/315785219/Sierra+Action+Role+Map
      */}
      {/* {roleEnum === RoleEnum.PROTOCOL_MANAGER && (
        <ButtonModal title={'Pool State'} modalWidth={900} variant="primary">
          <DynamicPauseResumeForm poolAddr={poolAddr} />
        </ButtonModal>
      )} */}

      {roleEnum === RoleEnum.ISSUER && (
        <ButtonModal title={'Set Indicative Interest & Collateral Rates'} modalWidth={900} variant="primary">
          <LytSetIndicativeInterestAndCollateralRateForm poolAddr={poolAddr} />
        </ButtonModal>
      )}
    </Box>
  )
}
